import { useReducer } from "react";
import GtAsset from "../pages/DesignAssets/GtAsset";
import { CBGTListReducer, initialCBGTList } from "../pages/DesignAssets/Reducers/CBGTListReducer";
const GtConfigDetailsModal = (props) => {
  const gtData = {...props};
  const [CBGTList, CBGTListDispatch] = useReducer( CBGTListReducer,initialCBGTList);
  const getGtAssetDetails = () => {
    return <GtAsset 
    configData ={gtData?.configData}
    CBGTList = {gtData?.CBGTList}
    selectedValues ={gtData?.selectedValues}
    assetDetailsDisplay= {gtData?.assetDetailsDisplay}
    setAssetSelection = {gtData?.setAssetSelection}
    gtChangeHandler = {gtData?.gtChangeHandler}
    gtCbConfigChangeHandler = {gtData?.gtCbConfigChangeHandler}
    updateGtCb = {gtData?.updateGtCb}
    closeGtConfigModal = {()=>gtData?.setIsOpenGtConfig(false)}
    />
  }     
const colseGtConfigModal = () =>{
  gtData?.setIsOpenGtConfig(false);
  // CBGTListDispatch({type:"PREV_GT_DATA",payload:{gtData:gtData?.CBGTList}})
};
  return (
   <se-dialog
    id="dialog-complex"
    size="large"
    open={gtData?.isOpenGtConfig}
    can-backdrop="false"
  >
    <se-dialog-header> Configure Grounding Transformer</se-dialog-header>

    <se-dialog-content className="se-dialog-content">
      {getGtAssetDetails()}
      </se-dialog-content>
    <se-dialog-footer>
      <se-button onClick={colseGtConfigModal} >Close</se-button>
    </se-dialog-footer>
  </se-dialog>
  );
};

export default GtConfigDetailsModal;